'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import React, { useEffect, useState } from 'react'

const EVENTO = 'vs-account'

/**
 * Header `.accountbutton`. The header is shared by statically generated pages, so it can't
 * read the cookie on the server: it asks `/api/clienti/me` in the browser instead (an admin's
 * cookie answers `null` there), again on every navigation. `/account` also announces the
 * session through `StatoAccount`, because login/logout redirect to that same path.
 */
export const AccountButton: React.FC = () => {
  const pathname = usePathname()
  const [nome, setNome] = useState<string | null>(null)

  useEffect(() => {
    const controller = new AbortController()
    fetch('/api/clienti/me', { credentials: 'include', signal: controller.signal })
      .then((res) => (res.ok ? res.json() : null))
      .then((dati: { user?: { nome?: string } | null } | null) => setNome(dati?.user?.nome ?? null))
      .catch(() => {})
    return () => controller.abort()
  }, [pathname])

  useEffect(() => {
    const aggiorna = (e: Event) => setNome((e as CustomEvent<string | null>).detail)
    window.addEventListener(EVENTO, aggiorna)
    return () => window.removeEventListener(EVENTO, aggiorna)
  }, [])

  return (
    <Link className="accountbutton" href="/account">
      <svg
        aria-hidden="true"
        fill="none"
        height="22"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        width="22"
      >
        <circle cx="12" cy="8" r="4" />
        <path d="M4 21c1.5-4 4.5-6 8-6s6.5 2 8 6" />
      </svg>
      <span>{nome ? `Ciao, ${nome}` : 'Accedi / Registrati'}</span>
    </Link>
  )
}

/** Rendered by `/account` with the server's view of the session; updates the header button. */
export const StatoAccount: React.FC<{ nome: string | null }> = ({ nome }) => {
  useEffect(() => {
    window.dispatchEvent(new CustomEvent(EVENTO, { detail: nome }))
  }, [nome])
  return null
}
